import { Controller } from 'react-hook-form';
import './element.scss';
import TimePicker from '../../../time-picker/time-picker';
import React from 'react';


interface DynamicTimeProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  formType?: string;
}

const DynamicTime = React.memo((props: DynamicTimeProps) => {

	return (
		<Controller
			control={props.formControl}
			name={`${props.fieldArrayName}.${props.name}`}
			render={({ field, fieldState }) => (
				<TimePicker
					{...field}
					onChange={(e) => {
						field.onChange(e);
						props?.onChange(e);
					}}
					dataPosition={props.position}
					dataName={`${props.fieldArrayName}.${props.name}`}
					label={props.label}
					placeholder={props.placeholder}
					required={props.formType === 'builder' ? false : props.required}
					is24hrFormat={props.options === '24hr'}
					disabled={props.disabled}
					helperText={fieldState.error?.message}
					error={Boolean(fieldState.error)}
					{...(props?.rest || {})}
				/>
			)}
		/>
	);
});
export { DynamicTime };
export default DynamicTime;
